import Banner from '../components/Banner.jsx';
import Counter from '../components/Counter.jsx';
import WhyJoinUs from '../components/WhyJoinUs.jsx';
import UpcomingEvents from '../components/UpcomingEvents.jsx';
import ImageSlider from '../components/ImageSlider.jsx';
import PartnerCTA from '../components/PartnerCTA.jsx';

function Home() {

  return (
    <>
      {/* <Header/> */}
      <Banner/>
      <Counter/>
      <WhyJoinUs />
      <UpcomingEvents />
      <ImageSlider/>
      <PartnerCTA/>
      {/* <Footer/> */}
    </>
  )
}

export default Home